import {getObjectClassName} from "./utils";

const registeredModels = {};

/**
 * @param {Object} models
 */
export function registerModels(models) {
    for (let [alias, classReference] of Object.entries(models)) {
        registerModel(alias, classReference)
    }
}

/**
 * @param {String} alias
 * @param {Object} classReference
 */
export function registerModel(alias, classReference) {
    registeredModels[alias] = classReference;
}

/**
 * @return {{}}
 */
export function getRegisteredModels() {
    return registeredModels;
}